import { render, staticRenderFns } from "./ItemThumb.vue?vue&type=template&id=58cedc45&scoped=true&"
import script from "./ItemThumb.vue?vue&type=script&lang=js&"
export * from "./ItemThumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cedc45",
  null
  
)

export default component.exports